import {TemplatesWebFrontendRequest} from "services-comun-ed/modules/services/templates/frontend-web";
import {IComponentWindow} from "./interface";
import {UserHeaderController} from "./inicio";

export class ValidacionPopupController {

    /* INSTANCE */
    public static instance: ValidacionPopupController;
    private validacion?: IComponentWindow;

    /* STATIC */
    public static async build(): Promise<ValidacionPopupController> {
        return ValidacionPopupController.instance = new this();
    }

    private constructor() {
    }

    public async getComponent(): Promise<IComponentWindow> {
        const data = await TemplatesWebFrontendRequest.loginPopUpValidacion();
        const validacion = new DOMParser().parseFromString(data.data, 'text/html').body.firstChild as HTMLElement;
        this.validacion = {
            window: validacion,
            buttons: {
                close: validacion.querySelector(".circulo-vl") as HTMLElement,
            }
        }
        await this.init();
        document.getElementsByTagName("body").item(0)?.appendChild(this.validacion.window);
        return this.validacion as IComponentWindow;
    }

    private async init() {
        this.validacion?.buttons?.close?.addEventListener("click", ()=>{
            this.validacion!.window.style.display = "none";
            UserHeaderController.instance.destroyOverlay();
        });
    }

}
